import { PRD4060_R01Dto } from "./Dto_PRD4060_R01";
import { deleteData, getData, postData, putData } from "src/utils/axios/serverHelper";
import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { PRD4060_R01Filter } from "./Store_PRD4060_R01";
import { formatDate } from "src/utils/string/stringUtil";

const baseUrl = `${config.apiUrl}/PRD4060_R01`;

const getParams = (filter: Partial<PRD4060_R01Filter>, listLength?: number) => {
    return {
		compCd: filter.compCd,
		downtimeCase: filter.downtimeCase,	
		startDate: filter.dateRange?.from ? formatDate(filter.dateRange.from) : undefined,
		endDate: filter.dateRange?.to ? formatDate(filter.dateRange.to) : undefined,
		productEmp: filter.productEmp,
		productEmpNm: filter.productEmpNm,
        listLength: listLength || 0
    }
}

// 리스트 조회
export const getPRD4060_R01List = async (option: string, params: Partial<PRD4060_R01Filter>, listLength: number = 0) => {
    const url = `${baseUrl}/${option}`;
    return await getData<ResponseDto<PRD4060_R01Dto[]>>(url, { params: getParams(params, listLength) });
}

export const getPRD4060_R01AllCount = async (params: Partial<PRD4060_R01Filter>) => {
    const url = `${baseUrl}/allCount`;
    return await getData<ResponseDto<number>>(url, { params: getParams(params, 0) });
}


// 엑셀 다운로드
export const exportPRD4060_R01Excel = async (option: string, params: Partial<PRD4060_R01Filter>, listLength: number = 0) => {
    const url = `${baseUrl}/excel/${option}`;
    return await getData<ResponseDto<string>>(url, { params: getParams(params, listLength) });
}

